import { Toaster as Sonner, toast } from "sonner"
import { useTheme } from "@/context/ThemeContext"

/*
 * App-wide toaster. Follows the IntelliSecure theme (ThemeContext), not the
 * OS, and is painted with the theme tokens so toasts read correctly in dark,
 * light and admin. Bottom-right on desktop; on phones it sits above the
 * bottom tab bar.
 */
const Toaster = ({
  ...props
}) => {
  const { theme } = useTheme()

  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      offset={{ bottom: 36, right: 16 }}
      mobileOffset={{ bottom: 72, left: 16, right: 16 }}
      closeButton
      // Sonner's default region name ("Notifications") collides with the topbar bell.
      containerAriaLabel="Toasts"
      className="toaster group"
      style={{
        "--normal-bg": "var(--surface-2)",
        "--normal-text": "var(--text-primary)",
        "--normal-border": "var(--border-strong)",
        "--border-radius": "var(--radius-lg)",
      }}
      toastOptions={{
        classNames: {
          toast: "group toast group-[.toaster]:shadow-lg",
          title: "group-[.toast]:font-semibold",
          description: "group-[.toast]:text-[color:var(--text-secondary)]",
          actionButton:
            "group-[.toast]:!bg-[color:var(--accent-from)] group-[.toast]:!text-[color:var(--text-on-accent)]",
          cancelButton:
            "group-[.toast]:!bg-[color:var(--surface-3)] group-[.toast]:!text-[color:var(--text-secondary)]",
          success: "[&_[data-icon]]:text-[color:var(--state-success)]",
          error: "[&_[data-icon]]:text-[color:var(--state-critical)]",
          warning: "[&_[data-icon]]:text-[color:var(--state-warning)]",
          info: "[&_[data-icon]]:text-[color:var(--state-info)]",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
